/**
 * Normalize Contentful asset URLs for next/image (often protocol-relative "//…").
 * @param {string | { fields?: { file?: { url?: string } } } | null | undefined} input
 * @returns {string | null}
 */
export function resolveContentfulImageSrc(input) {
  if (input == null) return null

  const raw = typeof input === 'string' ? input : input?.fields?.file?.url

  if (raw == null || typeof raw !== 'string') return null

  const u = raw.trim()
  if (!u) return null

  if (/^https?:\/\//i.test(u)) return u
  if (u.startsWith('//')) return `https:${u}`

  return `https://${u.replace(/^\/+/, '')}`
}
